<div class="p-10 h-full">
    <nz-page-header class="text-[16px] font-semibold p-0 pb-2 m-0" nzTitle="Configuración del sistema">
        <nz-page-header-extra class="flex">
            <nz-space>
                <button class="button primary-button" type="button" (click)="saveConfiguration()">
                    <div class="flex">
                        <img src="assets/icons/save-icon.svg" class="h-4 w-4" style="filter: invert(1);">&nbsp;
                        Guardar
                    </div>
                </button>
            </nz-space>
        </nz-page-header-extra>
    </nz-page-header>
    <div class="pb-10">
        <nz-divider></nz-divider>
        @for (conf of configurations; track conf.id) {
        @switch (conf.type) {
        @case (configurationsTypesEnum.STRING) {
        <div>
            <label>{{conf.name}}</label>
            <input onfocus="select()" nz-input [(ngModel)]="conf.value" type="text" [id]="conf.key"
                [title]="conf.description ? conf.description : ''" />
        </div>
        <nz-divider></nz-divider>
        }
        @case (configurationsTypesEnum.NUMBER) {
        <div>
            <label>{{conf.name}}</label>
            <input onfocus="select()" nz-input [(ngModel)]="conf.value" type="number" [id]="conf.key"
                [title]="conf.description ? conf.description : ''" />
        </div>
        <nz-divider></nz-divider>
        }
        @case (configurationsTypesEnum.BOOLEAN) {
        <div>
            <nz-switch [(ngModel)]="conf.value" [id]="conf.key" [title]="conf.description ? conf.description : ''"
                [class]="conf.value ? 'switch-on' : 'switch-off'"></nz-switch>
            <label>{{' ' + conf.name }}</label>
        </div>
        <nz-divider></nz-divider>
        }
        }
        }
    </div>

</div>